import { downloadData } from "aws-amplify/storage";
import { S3_PATHS } from "../../services/storage/constants";
import { useEffect, useState } from "react";

const cacheKeys = {
  countries: 'countries-cache',
  time: 'countries-cache-time',
}

const useCountriesData = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  useEffect(() => {
    const loadData = async () => {
      const cached = localStorage.getItem(cacheKeys.countries);
      const cacheTime = localStorage.getItem(cacheKeys.time);
      const isExpired = !cacheTime || (Date.now() - parseInt(cacheTime)) > (24 * 60 * 60 * 1000);
      if (cached && !isExpired) {
        const parseCached = JSON.parse(cached)
        if(Array.isArray(parseCached) && parseCached.length) {
          setData(parseCached);
          setLoading(false);
          return parseCached;
        }
      }
      
      try {
        const { body } = await downloadData({ path: S3_PATHS.COUNTRIES }).result;
        const jsonData = await body.text();
        const parsedData = JSON.parse(jsonData);
        if(Array.isArray(parsedData) && parsedData?.length) {
          const simplifiedCache = parsedData.map(({ name, regionType }) => ({ name, regionType }));
          localStorage.setItem(cacheKeys.countries, JSON.stringify(simplifiedCache));
          localStorage.setItem(cacheKeys.time, Date.now().toString());
    
          setData(parsedData);
        }
      } catch (error) {
        setError(true)
      } finally {
        setLoading(false);
      }
    };
    
    loadData();
  }, []);
  
  return { data, loading, error };
};

export default useCountriesData;